import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ChipsInputComponent } from './chips-input.component';

@NgModule({
    declarations: [ChipsInputComponent],
    imports: [CommonModule, FormsModule, TwcModule, TranslateModule],
    exports: [ChipsInputComponent],
})
export class ChipsInputModule {}
